import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const CookiePolicy: React.FC = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Cookie Policy</h1>
      <p className="legal-updated">Last updated: August 26, 2026</p>

      <p>
        PHI Printing uses a small amount of browser storage to make the site
        work. We use <strong>no analytics, advertising, or tracking cookies</strong>.
        This page lists everything we store in your browser.
      </p>

      <h2>Strictly necessary (no consent required)</h2>
      <ul>
        <li>
          <strong>Sign-in token</strong> — kept in local storage while you are
          signed in, so you stay signed in between pages. Removed when you sign
          out.
        </li>
        <li>
          <strong>Guest session ID</strong> — a random identifier that keeps
          your cart together while you shop as a guest. It contains no personal
          information.
        </li>
        <li>
          <strong>Cookie consent choice</strong> — remembers whether you
          accepted or declined optional storage, so we don't ask on every
          visit.
        </li>
      </ul>

      <h2>Optional (used only if you accept)</h2>
      <ul>
        <li>
          <strong>Theme preference</strong> — remembers your light/dark mode
          choice between visits. If you decline, the site still works; it just
          won't remember your theme.
        </li>
      </ul>

      <h2>Third parties</h2>
      <p>
        If you pay with PayPal, the PayPal button is loaded from PayPal's
        servers on the cart page and PayPal may set its own cookies under{' '}
        <a href="https://www.paypal.com/privacy" target="_blank" rel="noreferrer">PayPal's privacy policy</a>.
        If you pay with Square, payment happens on Square's checkout page under{' '}
        <a href="https://squareup.com/legal/privacy" target="_blank" rel="noreferrer">Square's privacy policy</a>.
      </p>

      <h2>Changing your choice</h2>
      <p>
        You can clear your browser's site data at any time to reset your
        consent choice — the banner will appear again on your next visit. For
        more about how we handle personal data, see the{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>
    </div>
  </div>
);

export default CookiePolicy;
